export const LoginMethodTypes = Object.freeze({
  SAML: 'Saml',
  GOOGLE: 'Google',
  AUTH0: 'Auth0',
  PASSWORD: 'UsernamePassword'
})
